import { useMutation } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { SubscriptionApi } from '@/Domain/api/Subscription/Subscription.api';

export const useManageSubscription = () => {
  const mutation = useMutation({
    mutationKey: [Endpoint.subscription.manage],
    mutationFn: () => SubscriptionApi.manage(),
    onSuccess: ({ session_url }) => {
      window.location.replace(session_url);
    },
  });

  const handleManage = () => mutation.mutate();

  return { handleManage, isPending: mutation.isPending };
};
